<template>
  <div class="video-item" ref="card">
    <div class="video-item-media">
      <div class="video-item-media-wrapper">
        <youtube v-if="youtubeId" :video-id="youtubeId" width="100%" height="100%" ref="youtube" @playing="playing" @paused="onPause" @ended="onPause" @ready="onReady"></youtube>
        <button class="play" @click="onPlay" v-if="!videoPlaying">
          <img :src="require('@/assets/images/play-btn.svg')" alt="play button">
        </button>
      </div>
    </div>
    <div class="video-item-detais">
      <div class="title">{{title}}</div>
      <div class="date">{{date}} | {{videoDuration}}</div>
    </div>
  </div>
</template>

<script>
  import { videoMixin } from '@/mixins/videoMixin'
  export default {
    name: 'video-item',
    props: {
      videoUrl: {
        type: String
      },
      title: {
        type: String
      },
      date: {
        type: String
      }
    },
    mixins: [videoMixin]
  }
</script>